angular.module('hotPointDetailPieModule', [])
    .directive('pieChartHotDir', ['$q', 'initHotHead', '$timeout', 'trsHttpService', function($q, initHotHead, $timeout, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionJsons: "="
            },
            link: function(scope, iElement, iAttrs) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '350px',
                        width: '100%'
                    };
                    if (scope.optionJsons === '') return;
                    var data = [],
                        dataT = [],
                        sumData = 0,
                        textX = '0';
                    for (var i = 0; i < scope.optionJsons.length; i++) {
                        dataT.push(scope.optionJsons[i].KEYWORD);
                        data.push({
                            value: scope.optionJsons[i].VALUE,
                            name: scope.optionJsons[i].KEYWORD,

                        })
                        sumData += scope.optionJsons[i].VALUE;
                    }
                    var n = 0;
                    var colors = ['#5A90F8', '#5EBDE9', '#FAB953', '#57CEC5', '#c3b4df'];
                    if($(window).width() >= 1920) {
                        textX = '33%';
                    } else {
                        textX = '31%';
                    }
                    var option = {
                        title: [{
                                text: '{headTitle|媒体渠道占比}',
                                textStyle: {
                                    rich: {
                                        headTitle: {
                                            color: '#3E3E3E',
                                            fontSize: 16
                                        }
                                    }
                                }
                            },
                            {
                                text: '{title|总渠道量}',
                                textStyle: {
                                    rich: {
                                        title: {
                                            fontSize: 14,
                                            color: '#999999',
                                            align: 'center',
                                            width: 90
                                        }
                                    }
                                },
                                subtext: '{subText|' + sumData + '}',
                                subtextStyle: {
                                    rich: {
                                        subText: {
                                            fontSize: 40,
                                            color: '#3E3E3E',
                                            align: 'center',
                                            width: 90,
                                        }
                                    }
                                },
                                itemGap: 20,
                                x: textX,
                                y: '39%'
                            }
                        ],
                        tooltip: {
                            show: true,
                            trigger: 'item'
                        },
                        legend: {
                            show: false
                        },
                        series: [{
                            name: '传播媒介',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            center: ['38%', '50%'],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                normal: {
                                    color: function() {
                                        return colors[n++];
                                    },
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            },
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: false,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data: data
                        }]
                    };
                    require(['echarts'], function(echarts) {
                        var myChart = echarts.init(iElement[0]);
                        myChart.setOption(option);
                        window.onresize = myChart.resize;
                    });
                }, 500);
            }
        };
    }]);